import { render } from "./UnicodeToPreeti.vue?vue&type=template&id=50640649"
import script from "./UnicodeToPreeti.vue?vue&type=script&lang=js"
export * from "./UnicodeToPreeti.vue?vue&type=script&lang=js"

import "./UnicodeToPreeti.vue?vue&type=style&index=0&id=50640649&lang=css"
script.render = render

export default script